export const SET_AUTH = 'SET_AUTH';
export const SET_AUTH_NAME = 'SET_AUTH_NAME';
export const SET_AUTH_LOG = 'SET_AUTH_LOG';
export const SET_TARGET = 'SET_ADMIN_TARGET';
export const SET_ALL_USER = 'SET_ALL_USER';
